query GetEventWebsitePageStatus($slug: String!) {
  eventWebsitePageStatus(slug: $slug)
}
